import React from 'react';
import './HowItWork.scss';
import rectangles from '../../assets/img/howItRectangles.svg';
import logoForMob from '../../assets/img/logo-for-mob.svg';
import { useInView } from 'react-intersection-observer';

function HowItWork({t}) {
  const{ ref,inView } = useInView({
    threshold:0,
  })
  return (
    <div className="work-main-wrapper">
         <div className="work-main">
      <div ref={ref} className={`work-capture animation ${inView ? 'show-work-capture': ""}`}>
        {t("how_it_wok_capture")}
      </div>
      <div ref={ref} className={`work-description animation ${inView ? 'show-work-description': ""}`}>
        {t("how_it_wok_description")}
      </div>
      <div className="work-wrapper">
        <div className="capture-block">
          <div ref={ref} className={`rectangles ${inView ? 'rectangles-show': ""}`}>
            <img src={rectangles} alt="" />
          </div>
        </div>
        <div className="work-description-wrapper">
          <div className="work-central-items">
            <div className={`work-item work-left ${inView ? 'left-show': ""}`}>
                <div className="capture-for-mob">{t("how_it_wok_capture_for_mob1")}</div>
              {t("how_it_wok_left_text")}
            </div>
            <div className={`work-item work-right  ${inView ? 'right-show': ""}`}>
                <div className="capture-for-mob"><img src={logoForMob} alt="" /></div>
                {t("how_it_wok_right_text")}
            </div>
          </div>
          <div className={`work-item work-bottom  ${inView ? 'work-bottom-show': ""}`}>
            <div className="capture-for-mob">{t("how_it_wok_capture_for_mob2")}</div>
            {t("how_it_wok_bottom_text")}
          </div>
        </div>
      </div>
    </div>
    </div>
   
    
  );
}

export default HowItWork;